<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      id="roleprojectsetting20211203"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.roleprojectsetting_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/crmedical/project/roleprojectsetting';
import { mapGetters } from 'vuex';
import { getProjectList } from '@/api/crmedical/project/project';
export default {
  data: function () {
    return {
      serachFlag: true,
      todoListLength: 1000000000000000,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      firstDisplayFlag: false,
      reWrite: false,
      tempProjectId: '',
      projectList: [],
      option: {
        dialogClickModal: false,
        dialogWidth: '65%',
        //    dialogHeight:432,
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        indexLabel: '序号',
        index: true,
        viewBtn: true,
        selection: true,
        columnBtn: true,
        refreshBtn: true,
        searchMenuSpan: 6,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '项目名称',
            prop: 'projectId',
            type: 'tree',
            searchClearable: false,
            editDisabled: true,
            search: true,
            dicUrl: '/api/v4ward/project/getProjectList',
            props: { label: 'name', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择项目名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '角色',
            prop: 'roleId',
            type: 'tree',
            search: true,
            dicUrl: '/api/v4ward/role/tree',
            props: { label: 'title', value: 'id' },
            rules: [
              {
                required: true,
                message: '请选择角色',
                trigger: 'change',
              },
            ],
          },
          {
            label: '权限类型',
            prop: 'permissionType',
            type: 'select',
            search: true,
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=permission_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择权限类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '描述',
            prop: 'description',
            type: 'textarea',
            maxlength: 300,
            showWordLimit: true,
            overHidden: true,
            span: 24,
            row: 4,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.roleprojectsetting_add, false),
        viewBtn: this.vaildData(this.permission.roleprojectsetting_view, false),
        delBtn: this.vaildData(this.permission.roleprojectsetting_delete, false),
        editBtn: this.vaildData(this.permission.roleprojectsetting_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //加载列表
    this.option.height = this.bodyHeight - 398 + 55;

    getProjectList({}).then((res) => {
      this.projectList = res.data;
      if (this.projectList.length > 0) {
        this.query.projectId = this.projectList[0].id;
        this.tempProjectId = this.projectList[0].id;
      }
      this.$nextTick(() => {
        this.reWrite = true;
        setTimeout(() => {
          this.$refs.crud.$children[1].$children[4].$el.addEventListener('click', () => {
            // console.log(this.option.height,this.bodyHeight);
            this.serachFlag = !this.serachFlag;
            if (this.todoListLength === 0) {
              if (this.option.height == this.bodyHeight - 398 + 55 + (78 - 46)) {
                this.option.height = this.bodyHeight - 287 + 1 + (78 - 46);
              } else {
                this.option.height = this.bodyHeight - 398 + 55 + (78 - 46);
              }
            } else {
              if (this.option.height == this.bodyHeight - 398 + 55) {
                this.option.height = this.bodyHeight - 287 + 1;
              } else {
                this.option.height = this.bodyHeight - 398 + 55;
              }
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  mounted() {
    console.log(this.$refs);
  },
  methods: {
    getProjectNameById(projectId) {
      let projectName = '';
      this.projectList.forEach(function (value, index, array) {
        if (value.id === projectId) {
          projectName = value.name;
          return;
        }
      });
      return projectName;
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query.permissionType = '';
      this.query.role = '';
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (!this.query.projectId) {
        this.query.projectId = this.tempProjectId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.todoListLength = data.records.length;
          if (this.serachFlag) {
            if (data.records.length === 0) {
              this.option.height = this.bodyHeight - 398 + (78 - 46) + 55;
            } else {
              this.option.height = this.bodyHeight - 398 + 55;
            }
            this.$refs.crud.getTableHeight();
          }
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="项目名称"]');
            ent.value = this.getProjectNameById(this.query.projectId);
            this.tempProjectId = this.query.projectId;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style>
#roleprojectsetting20211203 .avue-form__menu--center {
  padding-left: 125px !important;
}
</style>
